import TextField from "../../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { SolicitarFeriasService } from "../../../../services/SolicitarFeriasService";

export default {
  name: "FeriasVantagem",

  components: {
    TextField,
    PeriodoField,
    SelectField
  },

  props:{
    exercicios:{
      default:[]
    }
  },

  data: () => ({
    form: {},


    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.initializeForm();
  },



  methods: {
    

    prepareForm() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("exercicio", this.form.exercicio);
        formData.append("dias", this.form.numeroDias);

        this.sendForm(formData);
        return;
      }
      SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await SolicitarFeriasService.postFeriasVantagem(formData);
      this.loading.btn = false;
      if (response) {
        this.$refs.form.reset();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.form = {
        exercicio: "",
        numeroDias: ""
      }
    },

    close() {
      this.$emit("on-close");
    },
  }
};